function createScrollCallback(method, rTarget) {
  function scrollMethod(xOrOptions, y) {
    let counter = 0;
    function tryToScroll() {
      counter++;
      if (rTarget.current) {
        if (typeof xOrOptions === "number" && typeof y === "number") {
          rTarget.current[method](xOrOptions, y);
        }
        if (typeof xOrOptions !== "number") {
          rTarget.current[method](xOrOptions);
        }
      } else {
        if (counter < 20) {
          requestAnimationFrame(tryToScroll);
        } else {
          console.warn(`Impossible to ${method}`);
        }
      }
    }
    tryToScroll();
  }
  return scrollMethod;
}
export {
  createScrollCallback
};
//# sourceMappingURL=createScrollCallback.js.map
